const childRoutes = prop => [
    {
        path: 'hospital-service',
        name: prop + '.hospital_service',
        meta: { auth: true },
        component: () => import('../pages/hospital-service/Form.vue')
    },
    {
        path: 'disability-service',
        name: prop + '.disability_service',
        meta: { auth: true },
        component: () => import('../pages/disability-service/Form.vue')
    },
    {
        path: 'donation',
        name: prop + '.donation',
        meta: { auth: true },
        component: () => import('../pages/donation/Form.vue')
    }
]
const routes = [
    {
        path: '/hospital-disability-service/public-panel',
        name: 'hospital_disability_service.public-panel',
        component: () => import('@/layouts/HospitalDisabilityService.vue'),
        meta: { auth: true },
        children: childRoutes('hospital_disability_service.public_panel')
    }
]

export default routes
